module.exports = require('./ConsumerDiscountBranchApplicationView');
